module.exports = require('./ConsumerDiscountBranchApplicationView');
